package com.schoolconnect.app.feature.schoolusers.add

data class AddSchoolUserSchoolOption(
    val id: String,
    val name: String
)

data class AddSchoolUserFormValues(
    val staffId: String = "",
    val fullName: String = "",
    val staffRole: String = "",
    val mobileNumber: String = "",
    val emailAddress: String = "",
    val schoolId: String = "",
    val role: String = "",
    val gender: String = "",
    val status: String = "Active"
)

internal data class AddSchoolUserValidationErrors(
    val fullName: String = "",
    val staffId: String = "",
    val staffRole: String = "",
    val mobileNumber: String = "",
    val emailAddress: String = "",
    val schoolId: String = "",
    val role: String = "",
    val gender: String = "",
    val status: String = ""
) {
    val hasAnyError: Boolean
        get() = listOf(
            staffId,
            fullName,
            staffRole,
            mobileNumber,
            emailAddress,
            schoolId,
            role,
            gender,
            status
        ).any { it.isNotBlank() }
}

internal val addSchoolUserSchools = listOf(
    AddSchoolUserSchoolOption("oxford-public-school", "Oxford Public School"),
    AddSchoolUserSchoolOption("greenfield-high-school", "Greenfield High School"),
    AddSchoolUserSchoolOption("sunshine-public-school", "Sunshine Public School"),
    AddSchoolUserSchoolOption("viterine-school", "Viterine School"),
    AddSchoolUserSchoolOption("bright-future-school", "Bright Future School"),
    AddSchoolUserSchoolOption("nexus-international-school", "Nexus International School"),
    AddSchoolUserSchoolOption("sunrise-international-school", "Sunrise International School")
)

internal val addSchoolUserRoles = listOf("School Admin", "School Management")
internal val addSchoolUserGenders: List<String>
    get() = com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.labels("GENDER")
        .filter { it.equals("Male", ignoreCase = true) || it.equals("Female", ignoreCase = true) }

internal val addSchoolUserStatuses = listOf("Active", "Inactive")

internal fun defaultAddSchoolUserFormValues() = AddSchoolUserFormValues(status = "Active")

private val addSchoolUserPhoneRegex = Regex("^(\\+91)?[6-9]\\d{9}$")
private val addSchoolUserEmailRegex = Regex("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")

internal fun validateAddSchoolUser(values: AddSchoolUserFormValues): AddSchoolUserValidationErrors {
    fun required(value: String, message: String): String =
        if (value.trim().isBlank()) message else ""

    fun requiredPhone(value: String, message: String): String =
        if (value.trim().isBlank()) {
            message
        } else if (addSchoolUserPhoneRegex.matches(value.trim())) {
            ""
        } else {
            message
        }

    fun requiredEmail(value: String, message: String): String =
        if (value.trim().isBlank()) {
            message
        } else if (addSchoolUserEmailRegex.matches(value.trim())) {
            ""
        } else {
            message
        }

    return AddSchoolUserValidationErrors(
        staffId = required(values.staffId, "Staff ID is required"),
        fullName = required(values.fullName, "Full name is required"),
        staffRole = required(values.staffRole, "Staff role is required"),
        mobileNumber = requiredPhone(values.mobileNumber, "Enter a valid mobile number"),
        emailAddress = requiredEmail(values.emailAddress, "Enter a valid email address"),
        schoolId = required(values.schoolId, "School is required"),
        role = required(values.role, "Role is required"),
        gender = required(values.gender, "Gender is required"),
        status = required(values.status, "Status is required")
    )
}
